import React from 'react';
import TreeMenu from '../components/LeftTreeMenu/LeftTreeMenu';
import {Outlet} from "react-router-dom";
import MainMenu from './components/MainMenu';





const App3 = () => {
  // Your menu data
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-3">
            <MainMenu></MainMenu>
        </div>
        <div className="col-md-9">
          {/* Your main content goes here */}
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  );
};
export default App3;